<template lang="pug" functional>
.momentCard
  .momentCard-header(v-if="props.img" @click.prevent="listeners.zoomin")
    AppImg.momentCard-thumb(:srcset="props.img" :alt="props.title" :ratio="props.ratio" :autoRatio="props.autoRatio")
  .momentCard-body     
    h3.momentCard-title(v-if="props.title" itemprop="name")
      | {{ props.title }}
</template>

<script>
export default {
  name: 'MomentCard',
  props: {
    title: {
      type: String,
      default: null
    },
    img: {
      type: [String, Array],
      required: true
    },
    ratio: {
      type: String,
      default: ''
    },
    likes: {
      type: Number,
      default: 0
    },
    autoRatio: {
      type: Boolean,
      default: false
    },
    isActive: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="stylus">
.momentCard
  position: relative

  &-body
    padding: unitRes(20, 40)
    cursor: zoom-in

  &-title
    margin: 0
    font-size: unitRes(24, 40)
    font-weight: $fontWeight-medium

  &-header
    position: relative
    cursor: zoom-in

  &-thumb
    width: 100%
    height: auto
    display: block
    overflow: hidden
    transition: transform 0.4s ease-in-out

    >picture, >img
      transition: transform 0.4s ease-in-out

  &:hover
    .momentCard
      &-thumb
        transform: scale(0.97)

        .AppImg-main
          transform: scale(1.15)
</style>
